/**
 * usePriceHistory — Fetches OHLCV price candles for a token.
 *
 * Story 4.1: Token Detail API hooks
 */

import type { PriceInterval } from "@repo/shared-types";
import { useQuery } from "@tanstack/react-query";
import { tokensApi } from "../../lib/api";
import { tokenKeys } from "./query-keys";

const STALE_TIMES: Record<PriceInterval, number> = {
	"1H": 30_000,
	"4H": 30_000,
	"1D": 60_000,
	"1W": 60_000,
};

export function usePriceHistory(id: string, interval: PriceInterval) {
	return useQuery({
		queryKey: tokenKeys.priceHistory(id, interval),
		queryFn: async () => {
			const response = await tokensApi.getPriceHistory(id, interval);
			return response.data;
		},
		enabled: !!id,
		staleTime: STALE_TIMES[interval],
	});
}
